<template>
  <div class="my-integral-record container">
    <pi-tabs :list="tabsList" :active="tabs" @change="tabClick"></pi-tabs>
    <div class="container-flex" v-show="tabs == 1">
      <pi-record-tab pageType="integral-record"></pi-record-tab>
    </div>
    <div class="container-flex" v-show="tabs == 2" v-if="tabsTowShow">
      <pi-record-tab pageType="exchange-record"></pi-record-tab>
    </div>
  </div>
  
</template>
<script>
import piTabs from "@/components/pi-tabs/pi-tabs.vue";
import recordTab from "./components/record-tab/record-tab";

export default {
  name: "my-integral-record",
  components: {
    [piTabs.name]: piTabs,
    [recordTab.name]: recordTab,
  },
  data() {
    return {
      tabsList: [
        { name: "积分收支明细", value: '1' },
        { name: "积分兑换明细", value: '2' },
      ],
      tabs: '1',
      tabsTowShow: false,
    };
  },
  mounted() {},
  methods: {
    tabClick(item) {
      this.tabs = item.value;
      if (!this.tabsTowShow) {
        this.tabsTowShow = true;
      }
    },
  },
};
</script>
<style lang="less">
</style>